/* eslint-disable @typescript-eslint/camelcase */

import { BcsFlag, FcsFlag } from "../unleash";

const FcsFlagsSidebar = {
  permission_toggle_version_sidebar_enabled: new FcsFlag.Flag(false),
  permission_sidebar_v2_enabled: new FcsFlag.Flag(false)
};
const BcsFlagsSidebar = {
  config_sidebar_menu: new BcsFlag.JSONFlag()
};
export const FlagsSidebar = {
  ...FcsFlagsSidebar,
  ...BcsFlagsSidebar
};

export function initFlagsSidebar() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureSidebar", FcsFlagsSidebar);
  BcsFlag.register("featureSidebar", BcsFlagsSidebar);
}
